/**
 * Google event color palette — the Google half of the per-event color scheme
 * (parallel to `outlookCategoryColors.ts`).
 *
 * Google exposes a per-event `colorId` of `"1"`-`"11"`; we read it straight off
 * the provider payload and store it on `CalendarEvent.colorId`. The hexes reuse
 * the same modern Material values as the per-calendar fallback list so per-event
 * overrides and per-calendar colors share one visual vocabulary.
 *
 * This is also the unified swatch set the sidebar picker shows for *every* event
 * regardless of provider; for an Outlook event the picked id is translated to an
 * Outlook preset on write (see `api/src/clients/outlookCategoryColors.ts`).
 */
export const GOOGLE_EVENT_COLOR_PALETTE: { id: string; name: string; hex: string }[] = [
  { id: "1", name: "Lavender", hex: "#7986CB" },
  { id: "2", name: "Sage", hex: "#33B679" },
  { id: "3", name: "Grape", hex: "#8E24AA" },
  { id: "4", name: "Flamingo", hex: "#E67C73" },
  { id: "5", name: "Banana", hex: "#F6BF26" },
  { id: "6", name: "Tangerine", hex: "#F4511E" },
  { id: "7", name: "Peacock", hex: "#039BE5" },
  { id: "8", name: "Graphite", hex: "#616161" },
  { id: "9", name: "Blueberry", hex: "#3F51B5" },
  { id: "10", name: "Basil", hex: "#0B8043" },
  { id: "11", name: "Tomato", hex: "#D50000" },
];

const hexById = new Map(GOOGLE_EVENT_COLOR_PALETTE.map((c) => [c.id, c.hex]));

/** Resolve a Google event color id (`"1"`-`"11"`) to its hex, or undefined. */
export const getGoogleEventColorHex = (colorId: string | undefined): string | undefined =>
  colorId ? hexById.get(colorId) : undefined;
